import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changeDeal } from 'bundles/apex/deals/show/store/deal/actions';

import { faSign } from '@fortawesome/pro-solid-svg-icons';

import EmptyState from 'components/empty_state';
import Modal from 'bundles/apex/deals/connect_to_listing/modal';

import './styles.scss';

export function ListingEmptyState({ changeDeal, deal, edgeCrm }) {
  const [showModal, setShowModal] = useState(false);

  const handleSave = (listing, researchProperty = null) => {
    const changes = { listing };
    if (researchProperty) {
      changes.researchPropertyId = researchProperty.id;
      changes.researchProperty = researchProperty;
    }
    changeDeal(changes);
  };
  
  return (
    <React.Fragment>
      <EmptyState
        buttonText="Connect Listing"
        header="This deal isn't connected to a listing"
        icon={faSign}
        subheader="Click below to connect an existing listing or create a new one"
        onButtonClick={() => setShowModal(true)}
      />

      <Modal
        deal={deal}
        edgeCrm={edgeCrm}
        show={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleSave}
      />
    </React.Fragment>
  );
}

ListingEmptyState.propTypes = {
  changeDeal: PropTypes.func.isRequired,
  deal: PropTypes.object,
  edgeCrm: PropTypes.bool,
};

const mapStateToProps = state => ({
  deal: state.deal,
  edgeCrm: state.features.edgeCrm,
});

const mapDispatchToProps = {
  changeDeal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ListingEmptyState);
